export default "__VITE_ASSET__B7cv6GU3__"